"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trClassName = exports.Row = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function Row(_a) {
    var testId = _a.testId, restProps = __rest(_a, ["testId"]);
    return react_1.default.createElement(StyledTR, __assign({ className: exports.trClassName, "data-testid": testId }, restProps));
}
exports.Row = Row;
exports.trClassName = "newfront-spreadsheet--tr";
var StyledTR = styled_components_1.default.div({
    background: '#fff',
});
